import React from 'react';
import classNames from 'classnames';
import './styles.scss';

const CheckboxToggler = props => {
    return (
        <label className={classNames({
            'checkbox-toggler': true,
            ...props.modifiers
        })}>
            <input className="checkbox-toggler__input" type="checkbox" onChange={props.onChange} name={props.name} checked={props.checked === true ? true : false} />
            <div className="checkbox-toggler__ui"></div>
            {props.label &&
                <span className="checkbox-toggler__label">{props.label}</span>
            }
        </label>
    );
};

export default CheckboxToggler;